// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.view3d-switcher-buttons > button {
    transition: right 0.25s;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: -1;
}

div.view3d-switcher-buttons-expanded > button:nth-child(1) {
    right: 3.5em;
}

div.view3d-switcher-buttons-expanded > button:nth-child(2) {
    right: 7em;
}
`, "",{"version":3,"sources":["webpack://./components/map3d/style/View3DSwitcher.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd","sourcesContent":["div.view3d-switcher-buttons > button {\n    transition: right 0.25s;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: -1;\n}\n\ndiv.view3d-switcher-buttons-expanded > button:nth-child(1) {\n    right: 3.5em;\n}\n\ndiv.view3d-switcher-buttons-expanded > button:nth-child(2) {\n    right: 7em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
